
if($('.single-slider .slide-list .slide_box').length > 1){  
  $('.single-slider .slide-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
} 
  $('.loved-pieces .loved-pieces-sub').slick({
  dots: true,
  infinite: false,
     mobileFirst:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.new-arrivals .new-arrivals-sub').slick({
  dots: true,
  infinite: false,
     mobileFirst:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// $('.new-arrivals .new-arrivals-sub').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
     
//   ]
// });

$('.reviews-bg .customer-list').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



   $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  asNavFor: '.slider-nav'
});

  $('.slider-nav').slick({
      slidesToShow: 4,
      infinite: false,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
  }); 

	



// mobile menus toggle
$(document).on('click','.mobile-nav-trigger',function(e){
  document.querySelector("body").classList.remove('search-open');

  if ($('body').hasClass('menu-open')){
    $('body').removeClass('menu-open');
  } else {
    $('body').addClass('menu-open'); 
  }
});

$(document).on('click','.overlay-block',function(e){
// $('.overlay-block').on('click', function() {
  $('body').removeClass('menu-open');		  	
});

$(document).on('click','.mobile_svg',function(e){
  e.preventDefault();

  const $currentSubmenu = $(this).parent().find('.mega-menu-content');

  if ($currentSubmenu.hasClass('submenu_open')) {
      $currentSubmenu.removeClass('submenu_open');
  } else {
      $('.mega-menu-content').removeClass('submenu_open');
      $currentSubmenu.addClass('submenu_open');
  }
});
// mobile menus toggle ends


document.querySelector(".search-trigger").addEventListener("click",()=>{
  document.querySelector("body").classList.remove('menu-open');
  document.body.classList.toggle("search-open");
});


// document.querySelector(".close-icon").addEventListener("click",()=>{
//   document.body.classList.remove("search-open");
// });


// collection page on variant change update image and price
document.addEventListener("click", function (e) {
  const variantBtn = e.target.closest(".product_grid_variants");
  if (!variantBtn) return;

  const variantImage = variantBtn.dataset.variantImage;
  const variantPrice = variantBtn.dataset.variantPrice;

  // Find parent product item
  const productItem = variantBtn.closest(".product_grid_item");
  if (!productItem) return;

  const allVariants = productItem.querySelectorAll(".product_grid_variants");
  allVariants.forEach(v => v.classList.remove("active"));
  variantBtn.classList.add('active');

  // Update image
  const imgEl = productItem.querySelector(".product_grid_img");
  if (imgEl && variantImage) {
    imgEl.src = variantImage;
  }

  // Update price text
  const priceEl = productItem.querySelector(".product_grid_price");
  if (priceEl && variantPrice) {
    priceEl.textContent = variantPrice;
  }
});


